import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getSingleDataFromDatabase } from "../utils/api";
import { toast } from "react-toastify";

const ReportNavBar = () => {
    const navigate = useNavigate();
    const ppcid = localStorage.getItem("ppcdata");
    const [ppc, setPPC] = useState({});

    const { pathname } = useLocation();

    // Detect active child routes for mega menus
    const isTodayCallMenuActive =
        pathname.includes("/today-live-call-reports") ||
        pathname.includes("/today-team-report");

    const isYesterdayCallMenuActive =
        pathname.includes("/yesterday-call-report") ||
        pathname.includes("/yesterday-team-call-report");

    const isWeeklyCallMenuActive =
        pathname.includes("/last-week-call-report") ||
        pathname.includes("/process-report");

    const isManagementMenuActive =
        pathname.includes("/center-performance-report") ||
        pathname.includes("/agent-performance-report");

    const isProductMenuActive =
        pathname.includes("/top-product-by-state") ||
        pathname.includes("/top-product-by-cluster-head") ||
        pathname.includes("/product-performance-report");

    useEffect(() => {
        if (!ppcid) {
            navigate("/");
            return;
        }
        (async () => {
            try {
                const res = await getSingleDataFromDatabase(`ppc-get-single-data/${ppcid}`);
                if (res?.data?.status === 1) setPPC(res.data.ppcdata || {});
                else toast.error(res?.data?.message || "Failed to load PPC data");
            } catch (e) {
                console.error(e);
                toast.error("Network/CORS error while loading PPC data");
            }
        })();
    }, [ppcid, navigate]);


    const canSeeReports = Number(ppc?.ppc_report) === 1;
    const canSeeTeams = Number(ppc?.ppc_team) === 1;

    return (
        <div>

            <div className="page-wrapper mb-1">
                <div className="reportdiv">
                    <ul className="reportlink">
                        {/* Management Reports Mega Menu */}
                        <li className={`btnreport center-menu ${isTodayCallMenuActive ? "parent-active" : ""}`}>
                            <span className="center-menu-label">Today`s` Call Reports ▾</span>
                            <ul className="center-submenu">
                                <li>
                                    <NavLink to="/today-live-call-reports"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        T’day Calls
                                    </NavLink>
                                </li>
                                {canSeeTeams && (
                                    <li>
                                        <NavLink to="/today-team-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            T’day Team Calls
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </li>
                        <li className={`btnreport center-menu ${isYesterdayCallMenuActive ? "parent-active" : ""}`}>
                            <span className="center-menu-label">Y’day Call Reports ▾</span>
                            <ul className="center-submenu">
                                <li>
                                    <NavLink to="/yesterday-call-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Y’day Calls
                                    </NavLink>
                                </li>
                                {canSeeTeams && (
                                    <li>
                                        <NavLink to="/yesterday-team-call-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Y’day Team Calls
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </li>
                        <li className={`btnreport center-menu ${isWeeklyCallMenuActive ? "parent-active" : ""}`}>
                            <span className="center-menu-label">Weekly Call Reports ▾</span>
                            <ul className="center-submenu">
                                <li>
                                    <NavLink to="/last-week-call-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Last 7d Calls
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/process-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Process Report Last 7d
                                    </NavLink>
                                </li>

                            </ul>
                        </li>
                        <li className="btnreport">
                            <NavLink to="/day-wise-report">
                                <span>Compare Process</span>
                            </NavLink>
                        </li>
                        {/* Delivery Partner Mega Menu */}
                        <li className={`btnreport center-menu ${isProductMenuActive ? "parent-active" : ""}`}>
                            <span className="center-menu-label">Product Report ▾</span>
                            <ul className="center-submenu">
                                <li>
                                    <NavLink to="/top-product-by-state"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Top Product By State
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/product-performance-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Product Performance
                                    </NavLink>
                                </li>
                                {canSeeReports && (
                                    <li>
                                        <NavLink to="/top-product-by-cluster-head"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Top Product By Cluster Head
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </li>
                        {canSeeReports && (
                            <li className={`btnreport center-menu ${isManagementMenuActive ? "parent-active" : ""}`}>
                                <span className="center-menu-label">Management Reports ▾</span>
                                <ul className="center-submenu">
                                    <li>
                                        <NavLink to="/center-performance-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Center Performance
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/agent-performance-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Agent Performance
                                        </NavLink>
                                    </li>

                                </ul>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ReportNavBar;
